// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AdoptionChartIcon from '../AdoptionChartIcon';
// css
import '../../../styles/components/analytics/pptx/AdoptionOverviewChart.scss';


class AdoptionOverviewChart extends Component {

  aug_val(goalId, groupId, values) {
    const aug = values.find(aug =>
      (aug.analysisgoal === goalId) &&
      (aug.usergroup === groupId)
    );
    return aug && aug.value;
  }

  renderAreaGoalHeadings(area) {
    return area.goals.map(goal => (
      <th className='data-row' key={goal.id}>
        <div><span>{goal.title}</span></div>
      </th>
    ));
  }

  renderHeader() {
    const { areas } = this.props;

    return (
      <thead>
        <tr>
          <th className='analytics__adoption-overview-chart__top-left-cell'>&nbsp;</th>
          {areas.map(area => this.renderAreaGoalHeadings(area))}
        </tr>
        <tr>
          <th className='group-title'>Groups</th>
          {areas.map((area, index) => (
            <th
              key={index}
              className='analytics__adoption-overview-chart__area-title'
              colSpan={area.goals.length}
            >
              <div>{area.area.title}</div>
            </th>
          ))}
        </tr>
      </thead>
    );
  }

  renderGroupRow(group, groupIndex) {
    const { areas } = this.props;

    return (
      <tr key={groupIndex}>
        <th className='row-header'>{group.title}</th>
        {areas.map((area, areaIndex) => (
          area.goals.map((goal, goalIndex) => (
            <td key={[areaIndex, goalIndex].join('.')}>
              <AdoptionChartIcon value={this.aug_val(goal.id, group.id, area.values)} />
            </td>
          ))
        )).reduce((a, b) => a.concat(b))}
      </tr>
    );
  }

  renderBody() {
    const { groups } = this.props;

    return (
      <tbody>
        {groups.map((group, index) => this.renderGroupRow(group, index))}
      </tbody>
    );
  }

  render() {
    return (
      <div className='analytics__adoption-overview-chart'>
        <table className='table table-bordered table-striped'>
          {this.renderHeader()}
          {this.renderBody()}
        </table>
      </div>
    );
  }
}

AdoptionOverviewChart.propTypes = {
  areas: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired
};

export default AdoptionOverviewChart;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/AdoptionOverviewChart.js